export default {
  route: {
    fra: 'French',
    ewb: 'Ewbank',
    yds: 'Yosemite Decimal System (YDS)',
    ncc: 'National Climbing Classification System (NCCS)',
    gbr: 'British',
    uia: "Union internationale des associations d'alpinisme (UIAA)",
    zaf: 'South Africa',
    oza: 'South Africa (old)',
    sax: 'Sax',
    fin: 'Finnish',
    nor: 'Norwegian',
    pol: 'Polish',
    bra: 'Brazil',
    rus: 'Russian',
    swe: 'Swedish',
  },
  boulder: {
    vs: 'V Scale',
    bs: 'B Scale',
    ss: 'S Scale',
    ps: 'P Scale',
    jt: 'Joshua Tree',
    fb: 'Fontainebleau',
    fbt: 'Fontainebleau Traversée',
    abs: 'Annot B Scale',
  },
}
